"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectToAutoRefi = exports.redirectToHomeEquity = void 0;

var _queryString = _interopRequireDefault(require("query-string"));

var _constants = require("../constants");

var _factories = require("../factories");

var _windowGlobal3 = require("./window-global");

const createParams = params => {
  var _windowGlobal, _windowGlobal$locatio;

  const {
    search
  } = new _windowGlobal3.URL((_windowGlobal = (0, _windowGlobal3.windowGlobal)()) == null ? void 0 : (_windowGlobal$locatio = _windowGlobal.location) == null ? void 0 : _windowGlobal$locatio.href);

  const queryParams = _queryString.default.stringify({ ..._queryString.default.parse(search),
    ...params
  });

  return queryParams;
};

const redirectToProduct = (url, params) => {
  var _windowGlobal2, _windowGlobal2$locati;

  const queryParams = createParams(params);
  const redirectURL = `${url}?${queryParams}`;
  return (_windowGlobal2 = (0, _windowGlobal3.windowGlobal)()) == null ? void 0 : (_windowGlobal2$locati = _windowGlobal2.location) == null ? void 0 : _windowGlobal2$locati.assign(redirectURL);
};

const redirectToHomeEquity = intendedCredit => {
  redirectToProduct(_constants.HOME_EQUITY_URL, (0, _factories.createLoanProductParams)({
    intendedCredit
  }));
};

exports.redirectToHomeEquity = redirectToHomeEquity;

const redirectToAutoRefi = intendedCredit => {
  redirectToProduct(_constants.AUTO_REFI_URL, (0, _factories.createLoanProductParams)({
    intendedCredit
  }));
};

exports.redirectToAutoRefi = redirectToAutoRefi;